/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetDistrictQueryResult } from '../../models/get-district-query-result';

export interface ApiDistrictGetDistrictGet$Plain$Params {
  Id?: string;
}

export function apiDistrictGetDistrictGet$Plain(http: HttpClient, rootUrl: string, params?: ApiDistrictGetDistrictGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetDistrictQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiDistrictGetDistrictGet$Plain.PATH, 'get');
  if (params) {
    rb.query('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetDistrictQueryResult>;
    })
  );
}

apiDistrictGetDistrictGet$Plain.PATH = '/api/District/GetDistrict';
